import React, { useEffect, useState } from "react";
import "./AdvertiserDetails.css";
import NavbarComponent from "../../../components/navbar/NavbarComponent";
import Footer from "../../../components/footer/Footer";

function AdvertiserDetails() {
  const [isTab, setIsTab] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsTab(window.innerWidth <= 766);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 600);
      };
  
      handleResize();
  
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  return (
    <>
      <div className="advertiser-details">
        <NavbarComponent />

        <div
          className="container-fluid px-0"
          style={{ paddingBottom: "120px" }}
        >
          <div className="row px-0 mx-0 advertiser-details-page-section-1">
            <div className="col-md-6 pe-3">
              <div className="container-fluid px-0">
                <div className="row px-0">
                  <div className="col-12 px-0">
                    <div className="advertiser-details-page-card-1">
                      <div className="advertiser-details-page-card-1-image">
                        <img
                          src="/img/adv-detail-profile.svg"
                          className="advertiser-details-page-card-1-image-media"
                          alt=""
                        />
                      </div>
                      <div className="advertiser-details-page-card-1-details">
                        <h3
                          className="advertiser-details-page-card-1-details-name my-0"
                          style={{ textTransform: "capitalize" }}
                        >
                          OpenPath Realtors
                        </h3>
                        <p className="advertiser-details-page-card-1-details-desc my-0">
                          Los Angeles City, CA, USA | +848 032 03 01
                        </p>
                        <img
                          src="/img/social-image-adv.svg"
                          className="my-0"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-4 px-0">
                    <div className="advertiser-details-page-card-2">
                      <h2 className="advertiser-details-page-card-2-heading">
                        About OpenPath
                      </h2>
                      <p className="advertiser-details-page-card-2-desc">
                        As a third-generation realtor and Chicago native, Matt
                        has developed a profound understanding of the local real
                        estate market's dynamics. Raised in the south suburbs of
                        Chicago and a current resident of River North, he is
                        knowledgeable about each of the city’s vibrant
                        neighborhoods. He attended Eastern Illinois University
                        where he gained essential business knowledge and an
                        exceptional work ethic that serves his clients today.
                        <br />
                        Currently, Matt is the managing partner of Americorp and
                        heads the LARICY Team. He specializes in all aspects of
                        real estate. Whether it is assisting first-time home
                        buyers or dealing with luxury properties, he has
                        experienced it all.
                        <br />
                        Matt’s goal is to build lasting relationships with
                        clients through trust and transparency. To Matt, each
                        client is not merely a transaction, but the core and
                        success to his business. His approach has always been to
                        put his clients' interests first and provide
                        personalized service to cater to their individual needs
                        and real estate goals.
                        <br />
                        Outside of the office, Matt is a devoted husband and a
                        father to three wonderful children. His family inspires
                        him to work hard and fuels his desire to offer the best
                        possible service to clients.
                        <br />
                        With almost 20 years of experience and a true passion
                        for real estate, Matt continues to thrive in this
                        industry. He was ranked the #1 Agent in Chicago for
                        Volume & Transactions by the Chicago Association of
                        REALTORS® along with other awards multiple years in a
                        row.
                        <br />
                        Other accomplishments include being Chicago Agent’s
                        Industry MVP, the Top Team for Transactions by Chicago
                        Magazine, The Real Deal, & Crains, #1 in Illinois and #5
                        in the Nation for Wall Street Journal Real Trends
                        Medium-Sized Teams, and more. Matt continuously educates
                        others on current market trends through his LARICY LIVE
                        podcast.
                        <br />
                        Above all, Matt is committed to maintaining the high
                        standards of integrity and professionalism that the real
                        estate industry demands. Your real estate dreams are
                        Matt’s goals, and together we can make them a reality.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`col-md-6 ${isTab ? "px-0 mt-4" : "ps-3 pe-0"}`}>
              <div className="container-fluid advertiser-details-page-card-3">
                <div className="row">
                  <div className="col-md-6">
                    <h2 className="advertiser-details-page-card-2-heading">
                      Contact
                    </h2>
                    <div className="container-fluid">
                      <div className="row">
                    
                        <div className="col-12 advertiser-details-page-card-3-profile">
                          <div className="advertiser-details-page-card-3-image">
                            <div className="advertiser-details-page-card-3-image-media-2"></div>
                          </div>
                          <div className="advertiser-details-page-card-3-details">
                            <h3
                              className="advertiser-details-page-card-3-details-name my-0"
                              style={{ textTransform: "capitalize" }}
                            >
                              support@dealdirecthomes.com
                            </h3>
                          </div>
                        </div>
                        <div className="col-12 advertiser-details-page-card-3-profile">
                          <div className="advertiser-details-page-card-3-image">
                            <div className="advertiser-details-page-card-3-image-media-3"></div>
                          </div>
                          <div className="advertiser-details-page-card-3-details">
                            <h3
                              className="advertiser-details-page-card-3-details-name my-0"
                              style={{ textTransform: "capitalize" }}
                            >
                              California, United States
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`col-md-6 ${isTab ? "pt-4" : ""}`}>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6502595.146296284!2d-119.306607!3d37.2691675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2s!4v1741688036096!5m2!1sen!2s"
                      width="100%"
                      height={450}
                      style={{ border: 0, borderRadius: "20px" }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row px-0 mx-0 advertiser-details-page-section-2">
            <div className={`col-md-6 ${isTab ? "px-0" : "pe-3 ps-0"} `}>
              <div className="container-fluid advertiser-details-page-card-3">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="advertiser-details-page-card-2-heading">
                      Send a Message
                    </h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <form className="agent-register-form">
                      <input
                        type="text"
                        className="form-control send-message-input-field"
                        id="exampleInputEmail1"
                        placeholder="Full Name"
                        aria-describedby="emailHelp"
                      />

                      <input
                        type="text"
                        className="form-control send-message-input-field"
                        id="exampleInputPassword1"
                        placeholder="Email"
                      />
                      <div className="send-message-phone-number-group">
                        <button className="send-message-phone-code">+1</button>
                        <input
                          type="number"
                          className="form-control send-message-phone-field"
                          id="exampleInputPassword1"
                          placeholder="Phone Number"
                        />
                      </div>

                      <textarea
                        type="text"
                        className="form-control send-message-text-area"
                        id="exampleInputPassword1"
                        placeholder="Your Message"
                        rows={5}
                      />

                      <button className="btn agent-register-button">
                        Send Message
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AdvertiserDetails;
